<template>
  <v-container
    id="pedidos"
    tag="section"
  >
    <base-v-component heading="Pedidos " />
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
    ></v-text-field>
    <v-spacer></v-spacer>
    <v-btn
      color="success"
      @click="reload()"
      v-if="role == 'admin'"
    >
      <v-icon color="white">mdi-autorenew</v-icon>
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="pedidos"
      :loading="loading"
      :search="search"
      :must-sort="true"
      sort-by="fechaMoment"
      :sort-desc="true"
      :expanded.sync="expanded"
      show-expand
      item-key="id"
    >
      <template v-slot:item="{ item, isExpanded, expand }">
        <tr :class="item.eliminado
            ? 'red lighten-4'
            : item.solicitarEliminado
              ? 'yellow lighten-4'
              : ''
          ">
          <td>{{ item.numPedidoRest }}</td>
          <td>{{ item.numPedidoRestDia }}</td>
          <td>
            <!-- {{ item.hostname }} -->
            <v-tooltip
              top
              v-if="!!item.directorio"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  class="ml-2"
                  v-on="on"
                >mdi-store-24-hour</v-icon>
              </template>
              <span>Canal Directorio
                {{ item.copyDirectorio ? item.copyDirectorio.nombre : '-' }}
                mediante dominio {{ item.hostname }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-else
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  class="ml-2"
                  v-on="on"
                >mdi-store</v-icon>
              </template>
              <span>Canal Propio mediante dominio {{ item.hostname }}</span>
            </v-tooltip>
          </td>
          <td>{{ item.fecha }}</td>
          <td>{{ item.modo }}</td>
          <td>{{ item.formaPago }}</td>
          <td>{{ item.precioTotal }}</td>
          <td>{{ item.restauranteMostrar }}</td>

          <td>
            <!-- versión PC -->
            <v-row v-if="$vuetify.breakpoint.mdAndUp">
              <v-spacer></v-spacer>
              <v-tooltip
                top
                v-if="role == 'admin' &&
                  !!item.cobradoDesglose &&
                  !!item.cobradoDesglose[0] &&
                  !!item.cobradoDesglose[0].codigoFactura
                  "
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="px-2 ml-1"
                    color="black"
                    min-width="0"
                    small
                    v-on="on"
                  >
                    <v-icon
                      class="white--text"
                      small
                    >mdi-newspaper</v-icon>
                  </v-btn>
                </template>
                <span>Factura simplificada
                  {{
                    item.cobradoDesglose.map((c) => c.codigoFactura).join(', ')
                  }}</span>
              </v-tooltip>
              <v-badge
                :content="item.contadorMensaje"
                :value="item.contadorMensaje > 0"
                left
                color="secondary"
                overlap
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="px-2 ml-1"
                      color="primary"
                      min-width="0"
                      small
                      :loading="eliminar.loading"
                      v-on="on"
                      @click="openDialogHistorial(item)"
                    >
                      <v-icon
                        class="white--text"
                        small
                      >mdi-newspaper</v-icon>
                    </v-btn>
                  </template>
                  <span>Historial {{ item.id }}</span>
                </v-tooltip>
              </v-badge>
              <v-tooltip
                top
                v-if="item.neoEstado == 'ok'"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-btn
                      class="px-2 ml-1"
                      color="green"
                      min-width="0"
                      small
                      :loading="loadingNeo"
                    >
                      <v-icon
                        class="white--text"
                        small
                      >mdi-alpha-n-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-list
                  dense
                  class="ma-0"
                  shaped
                >
                  <v-subheader>ESTADO MAPEO NEO</v-subheader>
                  <v-list-item>Fecha intento:
                    {{ item.neoFechaIntento.toDate() }}</v-list-item>
                  <v-list-item>Mensaje: {{ item.neoMensaje }}</v-list-item>
                  <v-list-item>
                    <span class="secondary--text">ID NEO: {{ item.neoIdPedido }}</span>
                  </v-list-item>
                </v-list>
              </v-tooltip>
              <v-tooltip
                top
                v-else-if="item.neoEstado == 'intento'"
                class="pa-0"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="px-2 ml-1"
                    color="primary"
                    min-width="0"
                    small
                    :loading="eliminar.loading"
                    v-on="on"
                    @click="openDialogHistorial(item)"
                  >
                    <v-icon
                      class="white--text"
                      small
                    >mdi-newspaper</v-icon>
                  </v-btn>
                </template>
                <span>Historial {{ item.id }}</span>
              </v-tooltip>

              <v-tooltip
                top
                v-else-if="item.neoEstado == 'error' || item.neoEstado === false
                  "
                class="pa-0"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="px-2 ml-1"
                    color="red"
                    min-width="0"
                    small
                    :loading="loadingNeo"
                    v-on="on"
                    @click="mapearPedido(item)"
                  >
                    <v-icon
                      class="white--text"
                      small
                    >mdi-alpha-n-circle</v-icon>
                  </v-btn>
                </template>
                <v-list
                  dense
                  class="ma-0"
                  shaped
                >
                  <v-subheader>ESTADO MAPEO NEO</v-subheader>
                  <v-list-item>Fecha intento:
                    {{ item.neoFechaIntento.toDate() }}</v-list-item>
                  <v-list-item>Mensaje: {{ item.neoMensaje }}</v-list-item>
                  <v-list-item class="yellow--text">
                    <span class="secondary--text">Pulsar para reintentar mapeo</span>
                  </v-list-item>
                </v-list>
              </v-tooltip>
              <v-badge
                content="2"
                :value="!!item.stripeDobleVerificacion"
                right
                color="secondary"
                overlap
                v-if="datosAdmin"
              >
                <v-tooltip
                  top
                  v-if="mostrarCurrencyOn(item)"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="px-2 ml-1"
                      color="info"
                      min-width="0"
                      small
                      :loading="loadingRefund"
                      v-on="on"
                      @click="refundPedido(item)"
                    >
                      <v-icon small>mdi-currency-eur</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="role == 'admin'">Devolver Pago {{ role }}</span>
                  <span v-else>Si desea devolver el pago contacte con soporte</span>
                </v-tooltip>
              </v-badge>
              <v-tooltip
                top
                v-if="mostrarCurrencyOff(item)"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="px-2 ml-1"
                    color="red"
                    min-width="0"
                    small
                    v-on="on"
                  >
                    <v-icon small>mdi-currency-eur-off</v-icon>
                  </v-btn>
                </template>
                <span>El pago se ha devuleto</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="!!item.estadoReparto"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="openReparto(item)"
                    class="px-2 ml-1"
                    :color="item.repartoColor"
                    min-width="0"
                    small
                    v-on="on"
                  >
                    <v-icon
                      class="white--text"
                      small
                    >mdi-bike</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.repartoTexto }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="datosAdmin"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="px-2 ml-1"
                    :color="item.colorPrinter"
                    min-width="0"
                    small
                    :loading="loadingImprimir"
                    v-on="on"
                    @click="imprimirPedido(item)"
                  >
                    <v-icon
                      class="white--text"
                      small
                    >mdi-printer</v-icon>
                  </v-btn>
                </template>
                <span v-if="role == 'admin'">Imprimir {{ item.id }}</span>
                <span v-else>Estado de impresión</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="px-2 ml-1"
                    color="info"
                    min-width="0"
                    small
                    v-on="on"
                    @click="goView(item)"
                  >
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Ver pedido {{ item.id }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="role == 'admin'"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="!!item.eliminado"
                    class="px-2 ml-1"
                    color="red"
                    min-width="0"
                    small
                    :loading="eliminar.loading"
                    v-on="on"
                    @click="openEliminarDialog(item)"
                  >
                    <v-icon
                      class="white--text"
                      small
                    >mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar {{ item.id }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-else-if="role == 'admin'"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-btn
                      class="px-2 ml-1"
                      color="white"
                      min-width="0"
                      small
                      disabled
                      :loading="eliminar.loading"
                    >
                      <v-icon
                        class="white--text"
                        small
                      >mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Eliminado: {{ item.eliminadoMotivo }}</span>
              </v-tooltip>
            </v-row>
            <!-- versión móvil -->
            <v-menu
              transition="slide-x-transition"
              offset-y
              v-else
            >
              <template v-slot:activator="{ on, attrs }">
                <v-spacer></v-spacer>
                <v-btn
                  color=""
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  acciones
                </v-btn>
              </template>
              <v-card class="my-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-badge
                        :content="item.contadorMensaje"
                        :value="item.contadorMensaje > 0"
                        left
                        color="secondary"
                        overlap
                        class="mt-0"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="px-2 ml-1"
                              color="primary"
                              min-width="0"
                              small
                              :loading="eliminar.loading"
                              v-on="on"
                              @click="openDialogHistorial(item)"
                            >
                              <v-icon
                                class="white--text"
                                small
                              >mdi-newspaper</v-icon>
                            </v-btn>
                          </template>
                          <span>Historial {{ item.id }}</span>
                        </v-tooltip>
                      </v-badge>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="item.neoEstado == 'ok'">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-btn
                              class="px-2 ml-1"
                              color="green"
                              min-width="0"
                              small
                              :loading="loadingNeo"
                            >
                              <v-icon
                                class="white--text"
                                small
                              >mdi-alpha-n-circle</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <v-list
                          dense
                          class="ma-0"
                          shaped
                        >
                          <v-subheader>ESTADO MAPEO NEO</v-subheader>
                          <v-list-item>Fecha intento:
                            {{ item.neoFechaIntento.toDate() }}</v-list-item>
                          <v-list-item>Mensaje: {{ item.neoMensaje }}</v-list-item>
                          <v-list-item>
                            <span class="secondary--text">ID NEO: {{ item.neoIdPedido }}</span>
                          </v-list-item>
                        </v-list>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-else-if="item.neoEstado == 'intento'">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip
                        top
                        class="pa-0"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="px-2 ml-1"
                            color="yellow"
                            min-width="0"
                            small
                            :loading="loadingNeo"
                            v-on="on"
                            @click="mapearPedido(item)"
                          >
                            <v-icon
                              class="white--text"
                              small
                            >mdi-alpha-n-circle</v-icon>
                          </v-btn>
                        </template>
                        <v-list
                          dense
                          class="ma-0"
                          shaped
                        >
                          <v-subheader>ESTADO MAPEO NEO</v-subheader>
                          <v-list-item>Intentando Mapeo, sin respuesta</v-list-item>
                          <v-list-item class="yellow--text">
                            <span class="secondary--text">Pulsar para reintentar mapeo</span>
                          </v-list-item>
                        </v-list>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-else-if="item.neoEstado == 'error' || item.neoEstado === false
                  ">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip
                        top
                        class="pa-0"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="px-2 ml-1"
                            color="red"
                            min-width="0"
                            small
                            :loading="loadingNeo"
                            v-on="on"
                            @click="mapearPedido(item)"
                          >
                            <v-icon
                              class="white--text"
                              small
                            >mdi-alpha-n-circle</v-icon>
                          </v-btn>
                        </template>
                        <v-list
                          dense
                          class="ma-0"
                          shaped
                        >
                          <v-subheader>ESTADO MAPEO NEO</v-subheader>
                          <v-list-item>Fecha intento:
                            {{ item.neoFechaIntento.toDate() }}</v-list-item>
                          <v-list-item>Mensaje: {{ item.neoMensaje }}</v-list-item>
                          <v-list-item class="yellow--text">
                            <span class="secondary--text">Pulsar para reintentar mapeo</span>
                          </v-list-item>
                        </v-list>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="datosAdmin">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-badge
                        content="2"
                        :value="!!item.stripeDobleVerificacion"
                        right
                        color="secondary"
                        overlap
                        class="mt-0"
                      >
                        <v-tooltip
                          top
                          v-if="mostrarCurrencyOn(item)"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="px-2 ml-1"
                              color="info"
                              min-width="0"
                              small
                              :loading="loadingRefund"
                              v-on="on"
                              @click="refundPedido(item)"
                            >
                              <v-icon small>mdi-currency-eur</v-icon>
                            </v-btn>
                          </template>
                          <span v-if="role == 'admin'">Devolver Pago {{ role }}</span>
                          <span v-else>Si desea devolver el pago contacte con
                            soporte</span>
                        </v-tooltip>
                      </v-badge>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="mostrarCurrencyOff(item)">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="px-2 ml-1"
                            color="red"
                            min-width="0"
                            small
                            v-on="on"
                          >
                            <v-icon small>mdi-currency-eur-off</v-icon>
                          </v-btn>
                        </template>
                        <span>El pago se ha devuleto</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!!item.estadoReparto">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="openReparto(item)"
                            class="px-2 ml-1"
                            :color="item.repartoColor"
                            min-width="0"
                            small
                            v-on="on"
                          >
                            <v-icon
                              class="white--text"
                              small
                            >mdi-bike</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ item.repartoTexto }}</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="datosAdmin">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="px-2 ml-1"
                            :color="item.colorPrinter"
                            min-width="0"
                            small
                            :loading="loadingImprimir"
                            v-on="on"
                            @click="imprimirPedido(item)"
                          >
                            <v-icon
                              class="white--text"
                              small
                            >mdi-printer</v-icon>
                          </v-btn>
                        </template>
                        <span v-if="role == 'admin'">Imprimir {{ item.id }}</span>
                        <span v-else>Estado de impresión</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="px-2 ml-1"
                            color="info"
                            min-width="0"
                            small
                            v-on="on"
                            @click="goView(item)"
                          >
                            <v-icon small>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver pedido {{ item.id }}</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!item.eliminado && role == 'admin' && datosAdmin">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="px-2 ml-1"
                            color="red"
                            min-width="0"
                            small
                            :loading="eliminar.loading"
                            v-on="on"
                            @click="openEliminarDialog(item)"
                          >
                            <v-icon
                              class="white--text"
                              small
                            >mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar {{ item.id }}</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-else-if="role == 'admin'">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-btn
                              class="px-2 ml-1"
                              color="white"
                              min-width="0"
                              small
                              disabled
                              :loading="eliminar.loading"
                            >
                              <v-icon
                                class="white--text"
                                small
                              >mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Eliminado: {{ item.eliminadoMotivo }}</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-menu>
          </td>
          <td v-if="item.multiple">
            <v-icon
              @click="expand(true)"
              v-if="!isExpanded"
            >mdi-chevron-down</v-icon>
            <v-icon
              @click="expand(false)"
              v-if="isExpanded"
            >mdi-chevron-up</v-icon>
          </td>
        </tr>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col cols="12">
              <v-list dense>
                <v-subheader>ASOCIADOS</v-subheader>
                <v-list-item
                  :class="item.eliminado
                      ? 'red lighten-4'
                      : item.solicitarEliminado
                        ? 'yellow lighten-4'
                        : ''
                    "
                  dense
                  v-for="(p, i) in item.multipleHijosObj"
                  :key="i"
                >
                  <v-list-item-content>
                    <v-list-item-title> {{ p.id }} </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ p.precioTotal }}</v-list-item-subtitle><v-divider />
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-row dense>
                      <v-spacer></v-spacer>
                      <v-badge
                        :content="p.contadorMensaje"
                        :value="p.contadorMensaje > 0"
                        left
                        color="secondary"
                        overlap
                        class="mt-0"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="px-2 ml-1"
                              color="primary"
                              min-width="0"
                              small
                              v-on="on"
                              @click="openDialogHistorial(p)"
                            >
                              <v-icon
                                class="white--text"
                                small
                              >mdi-newspaper</v-icon>
                            </v-btn>
                          </template>
                          <span>Historial {{ p.id }}</span>
                        </v-tooltip></v-badge>

                      <v-tooltip
                        top
                        v-if="datosAdmin"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="px-2 ml-1"
                            :color="p.colorPrinter"
                            min-width="0"
                            small
                            :loading="loadingImprimir"
                            v-on="on"
                            @click="imprimirPedido(p)"
                          >
                            <v-icon
                              class="white--text"
                              small
                            >mdi-printer</v-icon>
                          </v-btn>
                        </template>
                        <span>Imprimir {{ item.id }}</span>
                      </v-tooltip>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
    <v-dialog
      v-model="eliminar.dialogo"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2 pb-4"
          primary-title
        >
          Motivo de la eliminación del pedido
          <h5>{{ eliminar.pedido ? eliminar.pedido.id : '' }}</h5>
        </v-card-title>
        <v-list>
          <v-list-item-group
            v-model="eliminar.motivo"
            mandatory
            color="primary"
          >
            <v-list-item
              v-for="item in eliminar.motivos"
              :key="item.value"
              :value="item.value"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon">{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
          <v-row v-if="eliminar.motivo == 'pasar'">
            <v-col
              cols="10"
              class="mx-auto"
            >
              <v-combobox
                :items="restaurantesNegocioEliminado"
                v-model="restaurantePasar"
                label="Restaurante a pasar"
              />
            </v-col>
          </v-row>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="eliminar.motivo == 'pasar'"
            @click="confirmarEliminar"
            :loading="eliminar.loading"
          >Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogHistorial"
      max-width="900"
    >
      <v-card class="mx-auto px-4">
        <v-row justify="center">
          <v-card-title class="mb-4">Historial</v-card-title>
          <v-card-subtitle>Pedido {{ editedItem.id }}</v-card-subtitle>
          <v-card-text>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(h, i) in historialComputed"
                :key="i"
              >
                <v-expansion-panel-header>
                  <v-row
                    no-gutters
                    align="center"
                  >
                    <v-col cols="1">
                      <v-chip class="grey white--text">{{
                        historialComputed.length - i
                      }}</v-chip>
                    </v-col>
                    <v-col cols="6">{{
                      h && h.mensaje ? h.mensaje : 'sin titulo'
                    }}</v-col>
                    <v-col
                      cols="2"
                      class="text--secondary"
                    >{{
                      h && h.usuario ? h.usuario : 'sin usuario'
                    }}</v-col>
                    <v-col
                      cols="3"
                      class="text--secondary"
                    >{{
                      h && h.fechaMostrar ? h.fechaMostrar : 'sin fecha'
                    }}</v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>{{
                  h && h.adicional ? h.adicional : 'Sin más información'
                }}</v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { mostrarMoneda, idToTexto } from '@/utils/utils.js';
import moment from 'moment-timezone';
export default {
  props: {
    datosAdmin: {
      //muestra acciones paara admin
      type: Boolean,
      default: true,
    },
    pedidosBruto: {
      type: Array,
      required: true,
    },
    mostrarDiaFecha: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      expanded: [],
      accionesDialog: false,
      loadingNeo: false,
      loadingRefund: false,
      loadingImprimir: false,
      loading: false,
      restaurantePasar: null,
      eliminar: {
        dialogo: false,
        loading: false,
        pedido: null,
        motivos: this.$store.state.pedidos.eliminarMotivos,
        motivo: 'pruebas',
      },
      search: '',
      editedItem: {
        historial: [],
      },
      dialogHistorial: false,
      headers: [
        {
          sortable: false,
          text: '#',
          value: 'numPedidoRest',
          width: '5%',
        },
        {
          sortable: false,
          text: '#Dia',
          value: 'numPedidoRestDia',
          width: '5%',
        },
        {
          sortable: false,
          text: 'Canal',
          value: 'canalVenta',
        },
        {
          sortable: false,
          text: 'Fecha',
          value: 'fecha',
        },
        {
          sortable: false,
          text: 'Modo',
          value: 'modo',
        },
        {
          sortable: false,
          text: 'Forma de pago',
          value: 'formas_pago',
        },
        {
          sortable: false,
          text: 'Cantidad',
          value: 'precioTotal',
        },
        {
          sortable: false,
          text: 'Restaurante',
          value: 'restauranteMostrar',
        },

        {
          sortable: false,
          text: 'Acciones',
          align: 'end',
          value: 'acciones',
          width: '20%',
        },
        { text: '', value: 'data-table-expand' },
      ],
    };
  },
  computed: {
    restaurantesNegocioEliminado() {
      return this.eliminar.pedido
        ? this.$store.state.app.restaurantesArray
          .filter((r) => r.negocio == this.eliminar.pedido.negocio)
          .map((r) => {
            return {
              text: r.nombre,
              value: r.id,
            };
          })
        : [];
    },
    historialComputed() {
      return this.editedItem.historial
        ? this.editedItem.historial
          .map((h) => {
            return {
              ...h,
              fechaMostrar: moment
                .unix(h.fecha)
                .format('DD-MM-YYYY HH:mm:ss'),
            };
          })
          .sort((a, b) => {
            return b.fecha - a.fecha - 1;
          })
        : [];
    },
    ...mapState({
      //pedidos : (state) => state.pedidos.pedidosArray
    }),
    ...mapGetters({
      //   pedidosBruto: "pedidos/getPedidosListado",
      role: 'auth/role',
    }),
    pedidos() {
      var res = [];
      this.pedidosBruto.forEach((pedR) => {
        //const aux = JSON.parse(JSON.stringify(pedR));
        const aux = pedR;
        let tlf =
          pedR.copyUser && pedR.copyUser.phoneNumber
            ? pedR.copyUser.phoneNumber
            : '-';
        aux.fecha = this.mostrarDiaFecha
          ? moment(aux.fechaServidor.toDate()).format('DD-MM-YYYY HH:mm')
          : moment(aux.fechaServidor.toDate()).format('HH:mm');
        aux.fechaMoment = moment(aux.fechaServidor.toDate()).unix();
        aux.restauranteMostrar = aux.multiple
          ? aux.copyDirectorio
            ? aux.copyDirectorio.nombre
            : 'Directorio sin nombre'
          : aux.copyNegocio && aux.copyNegocio.nombre +
          ' ' +
          (aux.copyRest ? aux.copyRest.nombre : '');
        aux.precioTotal = mostrarMoneda(aux.precioTotal);
        aux.formaPago = idToTexto(aux.forma_pago);
        aux.telefono = tlf;
        aux.contadorMensaje = pedR.historial
          ? pedR.historial.reduce(
            (n, h) => n + h.mensaje.includes('Mensaje desde la web'),
            0
          )
          : 0;
        // aux.dobleVerificacion = pedR.historial ? (pedR.historial.reduce((n, h) => n + (h.mensaje.includes('confirmado segunda verificación')), 0)) > 0 : false
        switch (pedR.printNodeEstado) {
          case 'enviadoImprimir':
            aux.colorPrinter = 'orange';
            break;
          case 'imprimido':
            aux.colorPrinter = 'green';
            break;
          default:
            aux.colorPrinter = 'red';
            break;
        }
        switch (
        pedR.estadoReparto //no-gestionado, creado, asignado, recogido, entregado, problema
        ) {
          case 'no-gestionado':
            aux.repartoColor = 'orange';
            aux.repartoTexto = 'Sin gestionarse';
            break;
          case 'creado':
            aux.repartoColor = 'yellow';
            aux.repartoTexto = 'Creado la petición de reparto';
            break;
          case 'asignado':
            aux.repartoColor = 'pink';
            aux.repartoTexto = 'Asignado a repartidor';
            break;
          case 'en-camino':
            aux.repartoColor = 'blue';
            aux.repartoTexto = 'En reparto';
            break;
          case 'entregado':
            aux.repartoColor = 'green';
            aux.repartoTexto = 'Entregado';
            break;
          case 'problema':
            aux.repartoColor = 'red';
            aux.repartoTexto = 'Problema en el reparto';
            break;
          default:
            aux.repartoColor = 'red';
            aux.repartoTexto = 'Sin más info';
            break;
        }
        if (aux.multiple) {
          let found = this.pedidosBruto.find((p) => p.multiple == aux.id);
          if (Array.isArray(aux.hijos)) {
            aux.hijos.push(found);
          } else {
            aux.hijos = [];
          }
        }
        res.push(aux);
      });
      //acoplamos pedidos multiple
      return res
        .map((multi) => {
          if (multi.multipleHijos && multi.multipleHijos.length > 0) {
            return {
              ...multi,
              multipleHijosObj: multi.multipleHijos.map((hijo) => {
                let found = res.find((p) => p.id == hijo);
                return found ? found : {};
              }),
            };
          } else {
            return multi;
          }
        })
        .filter((p) => !p.multiplePadre);
      //   return this.pedidosBruto.filter((p) => !p.multiplePadre);
    },
  },
  watch: {
    /*eliminar: {
    dialogo(oldV) {
      alert(oldV + " " + newV);
    },
    deep: true
  }*/
  },
  methods: {
    openReparto(item) {
      window.open(item.vromoEnlace, '_blank');
    },
    openDialogHistorial(item) {
      this.editedItem = item;
      this.dialogHistorial = true;
    },
    refundPedido(data) {
      if (this.role == 'admin') {
        const _vm = this;

        this.$confirm(
          '¿Desea devolver el dinero? Esta acción es irreversible?',
          {
            buttonTrueText: 'Aceptar',
            buttonFalseText: 'No',
            color: 'warning',
            icon: 'warning',
            width: 350,
          }
        )
          .then((res) => {
            if (res) {
              _vm.loadingRefund = true;
              return this.$store.dispatch('pedidos/refundPedido', data);
            }
          })
          .then((r) => {
            const d = r && r.data ? r.data : { ok: false };
            console.log(r);
            if (d.ok) {
              this.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Reembolso realizado',
              });
            } else {
              this.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Errorr al realizar el reembolso: ' + d.msg,
              });
            }
          })
          .catch((e) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Errorr al realizar el reembolso: ' + e,
            });
          })
          .finally(() => (_vm.loadingRefund = false));
      }
    },
    imprimirPedido(data) {
      const _vm = this;

      if (this.role == 'admin') {
        this.$confirm('¿Quiere imprimir el ticket?', {
          buttonTrueText: 'Si',
          buttonFalseText: 'No',
          color: 'warning',
          icon: 'warning',
          width: 350,
        })
          .then((res) => {
            if (res) {
              _vm.loadingImprimir = true;
              return this.$store.dispatch('pedidos/imprimirPedido', data);
            } else {
              return Promise.reject('cancelar');
            }
          })
          .then((r) => {
            const d = r.data;
            if (d.ok) {
              this.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Ticket impreso',
              });
            } else {
              this.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al imprimir el ticket: ' + d.error,
              });
            }
          })
          .catch((e) => {
            if (e != 'cancelar') {
              this.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al imprimir el ticket: ' + e,
              });
            }
          })
          .finally(() => (_vm.loadingImprimir = false));
      }
    },
    mapearPedido(data) {
      const _vm = this;
      this.$confirm('¿Quiere mapear el pedido?', {
        buttonTrueText: 'Si',
        buttonFalseText: 'No',
        color: 'warning',
        icon: 'warning',
        width: 350,
      })
        .then((res) => {
          if (res) {
            _vm.loadingNeo = true;
            return this.$store.dispatch('pedidos/mapearPedido', data);
          } else {
            return Promise.reject('cancelar');
          }
        })
        .then((r) => {
          const d = r.data;
          if (d.ok) {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Pedido mapeado con neo',
            });
          } else {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al mapear con Neo: ' + d.error,
            });
          }
        })
        .catch((e) => {
          if (e != 'cancelar') {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al mapear con Neo: ' + e,
            });
          }
        })
        .finally(() => (_vm.loadingNeo = false));
    },
    openEliminarDialog(item) {
      this.eliminar.dialogo = true;
      this.eliminar.pedido = item;
    },
    closeEliminarDialog() {
      this.eliminar.dialogo = false;
      this.eliminar.pedido = null;
      this.eliminar.motivo = 0;
    },
    confirmarEliminar() {
      const _vm = this;
      _vm.eliminar.loading = true;
      if (_vm.eliminar.motivo == 'pasar') {
        //pasamos a otro restaurante
        _vm.$store
          .dispatch('pedidos/pasarPedido', {
            pedido: _vm.eliminar.pedido.id,
            restaurante: _vm.restaurantePasar.value,
          })
          .then((res) => {
            this.closeEliminarDialog();
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Pedido pasado correctamente al restaurante',
            });
          })
          .catch((e) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al pasar el pedido: ' + e,
            });
          })
          .finally(() => (_vm.eliminar.loading = false));
      } else {
        console.log(_vm.eliminar);
        _vm.$store
          .dispatch('pedidos/eliminarPedido', {
            idpedido: _vm.eliminar.pedido.id,
            motivo: _vm.eliminar.motivo,
            multipleHijos: _vm.eliminar.pedido.multipleHijos
              ? _vm.eliminar.pedido.multipleHijos
              : false,
          })
          .then((res) => {
            this.closeEliminarDialog();
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Pedido eliminado',
            });
          })
          .catch((e) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al eliminar el pedido: ' + e,
            });
          })
          .finally(() => (_vm.eliminar.loading = false));
      }
    },
    mostrarCurrencyOn(item) {
      return item.stripeCobrado && item.stripeCobrado != 'refund';
    },
    mostrarCurrencyOff(item) {
      return (
        item.stripeCobrado == 'refund' && item.forma_pago == 'tarjeta_online'
      );
    },
    reload() {
      this.getPedidos();
    },
    getPedidos() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch('pedidos/getPedidosGlobal').finally(() => {
        _vm.loading = false;
      });
    },
    deleteItem(item) {
      let r = confirm('¿Quieres marcar como eliminado el pedido?');
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch('pedidos/deletePedido', item)
          .then((res) => {
            _vm.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Pedido marcado eliminado',
            });
            _vm.getPedidos();
          })
          .catch((error) => {
            _vm.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al eliminar: ' + error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    goView(item) {
      var str;
      switch (this.role) {
        case 'admin':
          str = '/admin/pedidos/view/' + item.id;
          break;
        case 'boss_directorio':
          str = '/admin/directorio/pedidos/ver/' + item.id;
          break;
        case 'boss_negocio':
          str = '/admin/negocio/pedidos/ver/' + item.id;
          break;
      }

      this.$router.push(str);
    },
  },
  mounted() {
    // this.$store.dispatch("pedidos/setRangoDefecto");
    // console.log(this.pedidosBruto);
  },
};
</script>

<style scoped>.border {
  border: 1px solid #000;
}</style>
